import { Activity } from "lucide-react";

export function MtgLogo({ className = "h-8 w-8", withText = false, name = "Medical Therapy Group", logoUrl = "", tagline = "Clinical Workspace" }) {
  return (
    <div className="flex items-center gap-2.5">
      {logoUrl ? (
        <img src={logoUrl} alt={name} className={`${className} rounded-lg bg-white object-contain p-0.5`} />
      ) : (
        <div className="relative grid place-items-center rounded-lg bg-teal-600 p-1.5 shadow-sm shadow-teal-900/30">
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" className={className}>
            <path d="M12 3v18M3 12h18" strokeLinecap="round" />
            <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="1.4" opacity="0.55" />
          </svg>
        </div>
      )}
      {withText && (
        <div className="leading-tight">
          <div className="font-heading text-sm font-extrabold tracking-tight text-white">{name}</div>
          <div className="flex items-center gap-1 text-[10px] font-medium uppercase tracking-widest text-teal-300/80">
            <Activity className="h-3 w-3" /> {tagline}
          </div>
        </div>
      )}
    </div>
  );
}
